import React from "react"

import { ProductConfigurationFormData } from "shared/types/ProductConfiguration"
import { RJSFSchema } from "shared/types/RJSF"

import { AddonAccordionAddonConfiguration } from "./AddonAccordionAddonConfiguration"

export interface AddonAccordionContentProps {
  addonKey: string
  schema?: RJSFSchema | null | undefined
  formData?: ProductConfigurationFormData
  isDisabled?: boolean
  isLoading?: boolean
  isConfigurable?: boolean
  onFormDataChange?: (
    formData: ProductConfigurationFormData["addons"],
    fieldID?: string
  ) => void
}

export const AddonAccordionContent = React.memo(
  (props: AddonAccordionContentProps) => (
    <div className="addon-accordion__content">
      <AddonAccordionAddonConfiguration {...props} />
    </div>
  )
)
